<template>
  <div class="public-app">
    <public-header
      @monthClick="toggleDatePicker"
      @menu="setMenu"
      :locale="locale"
      :showdatepicker="showdatepicker"
      :date="datePickerDate">
    </public-header>
    <pan-container
      v-if="showdatepicker"
      :active="isDatePickerReady"
      :date="datePickerDate"
      :theCalendarDate="date"
      @changed="setDatePickerDate"
      @setDate="setDate">
    </pan-container>
    <v-touch @tap="closeDatepicker"
             v-if="showdatepicker"
             class="overlay">
    </v-touch>
    <day-selector
      v-if="chosenView === 1"
      :date="date"
      :locale="locale"
      @changed="setDate">
    </day-selector>
    <!--- VIEWS -->
    <!-- DayCal -->
    <div v-show="load" class="load-spinner mobile">
      <div class="icon-docendo animated pulse infinite"></div>
    </div>
    <cal-container
      v-if="chosenView === 1"
      @eventClicked="showEvent"
      :i18n="i18n"
      :locale="locale"
      :date.sync="date"
      :dateChange="dateChange"
      :lessons="allEvents"
      :viewState="viewState">
    </cal-container>
    <!-- Weekplan -->
    <weekplan
      v-if="chosenView === 2"
      @close="closeWeekPlan"
      :calId="calId"
      :date="date"
      :events="allEvents"
      :locale="locale"
      :weeknote="weeknote">
    </weekplan>
    <week-calendar
      v-if="chosenView === 3"
      @eventClicked="showEvent"
      :calId="calId"
      :i18n="i18n"
      :date.sync="date"
      :dateChange="dateChange"
      :lessons="allEvents"
      :weeknote="weeknote"
      :viewState="viewState"
      :locale="locale">
    </week-calendar>
    <!-- FOOTER -->
    <!--
    <DAppCalendarNav
      @today="setDate(today)"
      @prev="prev"
      @next="next">
    </DAppCalendarNav>
    -->
    <footer-nav
      @today="setDate(today)"
      @prev="prev"
      @next="next"
      :isNotToday="isNotToday">
    </footer-nav>
    <sidenav
      :menu="menu"
      :chosenView.sync="chosenView"
      :schoolName="schoolName"
      :calName="calName"
      @close="menu = false"
      @afterLeave="getView"
      @locale="setLocale">
    </sidenav>
    <!-- <announcement></announcement> -->
  </div>
</template>

<script>
import publicHeader from './Header.vue'
import daySelector from '../../datepicker/DaySelect.vue'
import panContainer from './Datepicker/PanContainer.vue'
import calContainer from './DayCal/CalContainer.vue'
import footerNav from './FooterNav.vue'
import docendo from '../../../docendo' // eslint-disable-line no-unused-vars
import config from '../../../config' // eslint-disable-line no-unused-vars
import moment from 'moment' // eslint-disable-line no-unused-vars
import showEvent from '../ShowEvent.vue'
import weekplan from './WeekPlan/Container.vue'
import sidenav from './SideNav.vue'
import weekCalendar from './WeekCal/CalContainer.vue'
import announcement from '../SiteWideAnnouncement.vue'
import eventbus from '../../../eventbus'
import DAppCalendarNav from '../../DApp/DAppCalendarNav'

export default {
  components: {
    DAppCalendarNav,
    publicHeader,
    daySelector,
    calContainer,
    showEvent,
    panContainer,
    footerNav,
    weekplan,
    sidenav,
    weekCalendar,
    announcement
  },
  props: ['calId', 'viewState', 'weekplan', 'schoolName', 'calName', 'i18n'],
  data () {
    return {
      chosenView: 1,
      oldChosenView: 1,
      allEvents: [],
      date: config.now,
      today: config.now,
      dateChange: false,
      locale: moment.locale(),
      datePickerDate: config.now,
      showdatepicker: false,
      isDatePickerReady: false,
      weeknote: '',
      menu: false,
      start: config.now,
      end: config.now,
      load: true
    }
  },
  watch: {
    showdatepicker () {
      this.showdatepicker === false ? this.datePickerDate = this.date : null
    },
    date (val, oldVal) {
      if (moment(val).isoWeek() !== moment(oldVal).isoWeek()) {
        this.getWeekNote()
      }
    },
    chosenView (val, oldval) {
      this.oldChosenView = oldval
      try {
        if (typeof (Storage) !== 'undefined') {
          window.localStorage.setItem('chosenView', this.chosenView)
        }
      } catch (e) {
        // localstorage probably not enabled
      }
      this.getLessons()
    }
  },
  computed: {
    isNotToday () {
      return moment(this.date).locale('en').format('YYYY-MM-DD') !== moment(this.today).locale('en').format('YYYY-MM-DD')
    }
  },
  methods: {
    getView (val) {
      this.chosenView = val
    },
    setDate (date) {
      this.date = date
      this.datePickerDate = date
      this.dateChange = !this.dateChange
      this.getLessons()
      this.closeDatepicker()
    },
    closeDatepicker () {
      this.showdatepicker = false
      this.isDatePickerReady = false
    },
    setDatePickerDate (date) {
      this.datePickerDate = date
    },
    parseEvents (data) {
      var events = data
      if (typeof data === 'string') {
        try {
          events = JSON.parse(data)
        } catch (e) {
          events = []
        }
      }
      var parsed = Array.isArray(events) ? events : []
      var calId = this.calId * 1
      for (var i = 0; i < parsed.length; i++) {
        var ev = parsed[i]
        // Fjern advarselstrekanter
        delete ev.collision
        delete ev.away
        // Map calendars-array til flade group/teacher felter
        var calendars = ev.calendars || []
        var groups = []
        var teachers = []
        var rooms = []
        for (var j = 0; j < calendars.length; j++) {
          var cal = calendars[j]
          if (cal.calendar_type === 'klass' && cal.calendar_id !== calId) {
            groups.push(cal.name)
          } else if (cal.calendar_type === 'user') {
            teachers.push(cal.name)
          } else if (cal.calendar_type === 'room') {
            rooms.push(cal.name)
          }
        }
        ev.group = groups.join(', ')
        ev.teacher = teachers.join(', ')
        ev.room = rooms.join(', ')
        ev.canceled = ev.canceled || false
        ev.away = false
        ev.has_substitute = ev.has_substitute || false
        // Beregn duration i minutter fra start/end
        var startMoment = moment(ev.start)
        var endMoment = moment(ev.end)
        ev.duration = endMoment.diff(startMoment, 'minutes')
        // Sæt has_notes
        var desc = (ev.description || '').replace(/<[^>]*>/g, '').trim()
        var goal = (ev.learning_goal || '').replace(/<[^>]*>/g, '').trim()
        var studentNotes = (ev.notes_for_students || '').replace(/<[^>]*>/g, '').trim()
        var teacherNotes = (ev.teacher_notes || '').replace(/<[^>]*>/g, '').trim()
        ev.has_notes = !!(desc || goal || studentNotes || teacherNotes)
      }
      return parsed
    },
    getLessons () {
      var timer
      // Global event to make Calendar resize
      eventbus.loadingEvents = true
      timer = setTimeout(() => {
        this.load = true
      }, 300)
      let date = moment(this.date).locale('en').format('YYYY-MM-DD')
      if (this.chosenView !== 1) {
        this.start = moment(date).startOf('isoWeek').locale('en').format('YYYY-MM-DD 00:00')
        this.end = moment(date).endOf('isoWeek').locale('en').format('YYYY-MM-DD 23:59')
      } else {
        this.start = moment(date).startOf('day').locale('en').format('YYYY-MM-DD 00:00')
        this.end = moment(date).endOf('day').locale('en').format('YYYY-MM-DD 23:59')
      }
      docendo.publicEventsFromCalendar(this.calId, this.start, this.end, (data) => {
        clearTimeout(timer)
        this.load = false
        eventbus.loadingEvents = false
        this.allEvents = this.parseEvents(data)
      }, () => {
        clearTimeout(timer)
        this.load = false
        eventbus.loadingEvents = false
      })
    },
    getWeekNote () {
      let isoWeek = moment(this.date).isoWeek().toString().length < 2 ? '0' + moment(this.date).isoWeek() : moment(this.date).isoWeek()
      let week = moment(this.date).endOf('week').locale('en').format('YYYY') + 'W' + isoWeek
      docendo.weeknote(this.calId, week, (data) => {
        if (data.note === undefined) {
          this.weeknote = ''
        } else {
          this.weeknote = data.note
        }
      })
    },
    prev () {
      let prevDate
      if (this.chosenView !== 1) {
        prevDate = moment(this.date).subtract(7, 'days').isoWeekday(1)
      } else {
        prevDate = moment(this.date).subtract(1, 'days')
      }
      this.setDate(prevDate)
    },
    next () {
      let nextDate
      if (this.chosenView !== 1) {
        nextDate = moment(this.date).add(7, 'days').isoWeekday(1)
      } else {
        nextDate = moment(this.date).add(1, 'days')
      }
      this.setDate(nextDate)
    },
    showEvent (event) {
      this.$emit('eventClick', event)
    },
    setLocale (val) {
      this.locale = val
      this.$emit('setLocale', val)
    },
    closeWeekPlan () {
      this.chosenView = this.oldChosenView
    },
    setMenu () {
      this.closeDatepicker()
      this.menu = true
    },
    toggleDatePicker () {
      if (!this.showdatepicker) {
        this.showdatepicker = true
        setTimeout(_ => {
          this.isDatePickerReady = true
        }, 0)
      } else {
        this.closeDatepicker()
      }
    }
  },
  beforeMount () {
    try {
      if (typeof (Storage) !== 'undefined') {
        if (window.localStorage.getItem('chosenView') !== null) {
          this.chosenView = window.localStorage.getItem('chosenView') * 1
        }
      }
    } catch (e) {
      // localstorage probably not enabled
    }
  },
  mounted () {
    this.getLessons()
    this.getWeekNote()
  },
  updated () {
    document.title = this.calName
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.public-app {
  overflow: hidden;
  position: relative;
  max-width: 100%;
  height: 100vh;
  background: white;
}

.overlay {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 5;
  opacity: 0;
  height: 100%;
  width: 100%;
}

.load-spinner {
  position: absolute;
  top: 120px;
  right: 0;
  left: 0;
  bottom: 55px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 100px;
  color: var(--blue);
}

</style>



// WEBPACK FOOTER //
// MobileView.vue?58bb7e90